import React from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import renderTextField from '../../components/MaterialUi/renderTextField';
import RFSelectField from '../../components/ReduxFormComps/RFSelectField';
import RFDatePickerField from '../../components/ReduxFormComps/RFDatePickerField';
import styles from './common/styles';
import Paper from '@material-ui/core/Paper'
import ContentRowSpace from './common/ContentRowSpace'

class DocFormPhysician extends React.Component {
    
    shouldComponentUpdate(nextProps, nextState) {
        return false
    } 

    render(){
        const { gorgon } = this.props;
        
        return (
            <div>
                <Paper>
                    <div className="container">
                        <ContentRowSpace />
                        <div className="row">
                            <div className='col-sm'>
                                <Field
                                    name="physicianFirstName"
                                    component={renderTextField}
                                    label="Physician First Name"
                                    style={styles.nameTextFieldStyle}
                                />
                            </div>
                            <div className='col-sm'>
                                <Field
                                    name="physicianLastName"
                                    component={renderTextField}
                                    label="Physician Last Name"
                                    style={styles.nameTextFieldStyle}
                                />
                            </div>
                        </div> 
                        <div className="row">
                            <div className='col-sm'>
                                <Field
                                    name="physicianClinicName"
                                    component={renderTextField}
                                    label="Physician Clinic Name"
                                    style={styles.nameTextFieldStyle}
                                />
                            </div>
                        </div>  
                        <div className="row">
                            <div className='col-sm'>
                                <Field
                                    name="physicianAddrLine1"
                                    component={renderTextField}
                                    multiline
                                    rowsMax="2"
                                    label="Physician Address Line 1"
                                    style={styles.addrTextFieldStyle}
                                />
                            </div>
                            <div className='col-sm'>
                                <Field
                                    name="physicianAddrLine2"
                                    component={renderTextField}
                                    multiline
                                    rowsMax="2"
                                    label="Physician Address Line 2"
                                    style={styles.addrTextFieldStyle}
                                />
                            </div>
                        </div>    
                        <div className="row">
                            <div className='col-sm'>
                                <Field
                                    name="physicianCity"
                                    component={renderTextField}
                                    label="Physician City"
                                    style={styles.addrTextFieldStyle}
                                />
                            </div>
                            <div className='col-sm'>
                                <Field
                                    label="Physician State"
                                    name="physicianState"
                                    datas={gorgon.states}
                                    component={RFSelectField}
                                    codeField={'code'}
                                    descField={'name'}
                                    customStyle={styles.addrTextFieldStyle}
                                />
                            </div>
                        </div> 
                        <div className="row">
                            <div className='col-sm'>
                                <Field
                                    name="physicianZip"
                                    component={renderTextField}
                                    label="Physician Zip"
                                    style={styles.addrTextFieldStyle}
                                />
                            </div>
                            <div className='col-sm'>
                                <Field
                                    name="physicianPhoneNum"
                                    component={renderTextField}
                                    label="Physician Phone Number"
                                    style={styles.nameTextFieldStyle}
                                />
                            </div>
                        </div>    
                        <div className="row">
                            <div className='col-sm'>
                                <Field
                                    name="lastConsultDate"
                                    component={RFDatePickerField}
                                    label="Last Consult Date"
                                    inputDateFormat='MM/DD/YYYY'
                                    style={styles.nameTextFieldStyle}
                                    inputNote="US date format MM/DD/YYYY"
                                />
                            </div>
                            <div className='col-sm'>
                                <Field
                                    name="lastConsultReason"
                                    component={renderTextField}
                                    label="Last Consult Reason"
                                    style={styles.nameTextFieldStyle}
                                />
                            </div>
                        </div>    
                        <ContentRowSpace />
                    </div>
                </Paper>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        gorgon: state.gorgon
    }
}

export default connect(mapStateToProps)(DocFormPhysician);


// WEBPACK FOOTER //
// ./src/views/ProjectGorgon/DocFormPhysician.js